import { render, staticRenderFns } from "./ReferralDetailsTabs.vue?vue&type=template&id=47f50d52&"
import script from "./ReferralDetailsTabs.vue?vue&type=script&lang=ts&"
export * from "./ReferralDetailsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralDetailsTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports